// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=8369ad6d-3e15-4b03-b023-0c31f52b89b1";
};